import React from 'react';
import { isRunningInBiltNativeShell } from '../../utils/nativeShell';
import { useShowModeAsset } from '../../contexts/ShowModeAssets';

type BuiltBrandLockupProps = {
  /** Visual height of the lockup image */
  heightClass?: string;
  className?: string;
  /** Show Beta chip beside the lockup (header) */
  showBeta?: boolean;
};

const NAV_LOCKUP_SRC = '/brand/logo-lockup-nav.png?v=20260826';
const NAV_LOCKUP_SRC_2X = '/brand/logo-lockup-nav-2x.png?v=20260826';

/**
 * Horizontal brand lockup: orange bar + wrench-B + BiLT + :SPEC.
 * Transparent PNG — designed for dark chrome.
 */
export const BuiltBrandLockup: React.FC<BuiltBrandLockupProps> = ({
  heightClass = 'h-9',
  className = '',
  showBeta = false,
}) => {
  const asset = useShowModeAsset();
  return (
  <span className={`inline-flex items-center gap-2.5 min-w-0 ${className}`}>
    <img
      src={asset(NAV_LOCKUP_SRC)}
      srcSet={`${asset(NAV_LOCKUP_SRC)} 1x, ${asset(NAV_LOCKUP_SRC_2X)} 2x`}
      alt="Bilt:Spec"
      className={`${heightClass} w-auto max-w-[min(100%,220px)] object-contain object-left`}
      draggable={false}
    />
    {showBeta && !isRunningInBiltNativeShell() && (
      <span className="hidden sm:inline-flex text-[9px] font-semibold tracking-[0.2em] text-orange-400 uppercase shrink-0">
        Beta
      </span>
    )}
  </span>
);
};

export default BuiltBrandLockup;
